// extracted by mini-css-extract-plugin
module.exports = {"content":"Hero_content__Lsyn5","inner":"Hero_inner__-WPWq","logo":"Hero_logo__QxsLj","cta":"Hero_cta__5zajw"};